import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { TimeClock } from './TimeClock';
import { useEmployee } from '../contexts/EmployeeContext';

interface TopBarProps {
  title: string;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  searchPlaceholder?: string;
  onMenuClick?: () => void;
}

export const TopBar: React.FC<TopBarProps> = ({
  title,
  searchQuery,
  onSearchChange,
  searchPlaceholder = "Search orders, products...",
  onMenuClick
}) => {
  const { isLoggedIn } = useEmployee();

  return (
    <div className="bg-white border-b border-slate-200 px-4 lg:px-8 py-3 sm:py-4 sticky top-0 z-30 safe-pt safe-px">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center space-x-3">
          {/* Hamburger menu - only on mobile */}
          {onMenuClick && (
            <button
              onClick={onMenuClick}
              className="lg:hidden p-2 -ml-2 rounded-lg hover:bg-slate-100 text-slate-600 tap-target"
              aria-label="Open navigation"
            >
              <Bars3Icon className="w-6 h-6" />
            </button>
          )}
          <h1 className="text-xl lg:text-2xl font-semibold text-slate-900">{title}</h1>
        </div>

        <div className="flex items-center space-x-2 lg:space-x-4">
          {/* Employee Time Clock - shows when employee is logged in */}
          {isLoggedIn && <TimeClock />}

          {/* Search - hidden on mobile */}
          {onSearchChange && (
            <div className="relative hidden md:block">
              <input
                type="text"
                placeholder={searchPlaceholder}
                value={searchQuery || ''}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-64 lg:w-80 px-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-blue focus:border-transparent"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
